import { render, staticRenderFns } from "./PuzzleForm.vue?vue&type=template&id=0a01a1b8&scoped=true&"
import script from "./PuzzleForm.vue?vue&type=script&lang=js&"
export * from "./PuzzleForm.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleForm.vue?vue&type=style&index=0&id=0a01a1b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a01a1b8",
  null
  
)

export default component.exports